export default {
  'Edit': 'تحرير',
  'Save': 'حفظ',
  'Cancel': 'إلغاء',
  'Ok': 'حسنا',
  'and': 'وأيضا',
  'Yes': 'نعم',
  'No': 'لا',
  'Or': 'او',
  'Confirm': 'تأكيد',
  'Saved success': 'حفظت بنجاح',
  'Warning': 'تحذير',
  'Cancel success': 'إلغاء بالنجاح',
  'Account binding failure': 'فشل ربط الحساب',
  'UPDF Code verify': 'التحقق من رمز UPDF',
  'UPDF Login': 'تسجيل الدخول إلى UPDF',
  'UPDF Password login': 'تسجيل الدخول بكلمة مرور UPDF',
  'UPDF Forgot password': 'UPDF نسيت كلمة المرور',
  'UPDF Reset password': 'UPDF إعادة تعيين كلمة المرور',
  'UPDF Set account info': 'UPDF تعيين معلومات الحساب',
  'UPDF Callback {loginType}': 'رد اتصال UPDF {نوع تسجيل الدخول}',
  'UPDF Wechat login': 'تسجيل الدخول إلى UPDF Wechat',
  'Welcome to': 'مرحبا بك في',
  'Wechat': 'برنامج Wechat',
  'Click reload': 'انقر فوق إعادة التحميل',
  'Log in by scanning QR code on Wechat<br>and following our official account': 'قم بتسجيل الدخول عن طريق مسح رمز الاستجابة السريعة على Wechat<br>ومتابعة حسابنا الرسمي',
  'Email': 'بريد الكتروني',
  'Phone': 'رقم الهاتف',
  'Unregistered account will be registered after entering the verification code': 'سيتم تسجيل رقم الهاتف أو البريد الإلكتروني غير المسجل بعد إدخال رمز التحقق',
  'Unregistered email will be registered after entering the verification code': 'سيتم تسجيل البريد الإلكتروني غير المسجل بعد إدخال رمز التحقق',
  'Or continue with:': 'أو تابع مع:',
  'By clicking continue, you accept our': 'بالنقر على "متابعة"، فإنك توافق على قبول',
  'License Agreement': 'اتفاقية الترخيص',
  'Privacy Policy': 'سياسة الخصوصية',
  'Enter your phone number or email...': 'أدخل رقم هاتفك أو بريدك الإلكتروني...',
  'Enter your email address...': 'أدخل عنوان بريدك الالكتروني...',
  'Please enter a valid phone number or email': 'الرجاء إدخال رقم هاتف أو بريد إلكتروني مفعل',
  'Please enter a valid email address': 'يرجى إدخال عنوان بريد إلكتروني مفعل',
  'Please enter your password': 'من فضلك أدخل رقمك السري',
  'Enter new password': 'ادخل كلمة المرور الجديدة',
  'The new password must be at least {min} characters.': 'يجب ان يتكون الرمز السري الجديد علي الآقل {min} احرف',
  'The new password must be within {max} characters.': 'يجب أن تكون كلمة المرور الجديدة {max} ضمن من الأحرف.',
  'Nickname must be within {max} characters.': 'يجب أن يكون الاسم المستعار ضمن {max} من الأحرف.',
  'Enter your password again': 'أدخل كلمة المرور الجديدة مرة أخرى',
  'Please enter your password again': 'الرجاء إدخال كلمة المرور الخاصة بك مرة أخرى',
  'Those passwords didn\'t match. Try again.': 'كلمات المرور هذه غير متطابقة. حاول ثانية.',
  'Reset success,please log in use new password': 'تمت إعادة الضبط بنجاح، يرجى تسجيل الدخول باستخدام كلمة المرور الجديدة',
  'Continue': 'استمر',
  'Check mobile': 'تحقق من الجوال',
  'Check email': 'تفقد البريد الإلكتروني',
  'Please enter the code sent to<br><span>{account}</span>': 'الرجاء ادخال الرمز المرسل إلى<br><span>{account}</span>. الرمز صالح لمدة 10 دقائق.',
  'If you do not receive the email, please check your spam or junk folder.': 'إذا لم تتلقى البريد الإلكتروني، يرجى التحقق من مجلد الرسائل المهمله أو البريد غير المرغوب فيه.',
  'Resend': 'اعاده ارسال',
  'seconds remaining to resend code': 'الثواني المتبقية لإعادة إرسال الرمز',
  'Verify Later': 'التحقق لاحقا',
  'Log in with password': 'الدخول مع كلمه المرور',
  'Log in with password-2': 'تسجيل الدخول بكلمة المرور',
  'Log in with code': 'تسجيل الدخول برمز التحقق',
  'OR': 'او',
  'Back': 'الرجوع',
  'Forgot password?': 'هل نسيت كلمة السر؟',
  'Log in': 'تسجيل الدخول',
  'Set password': 'ضبط كلمة السر',
  'Reset your password': 'اعد ضبط كلمه السر',
  'Add a photo': 'إضافة صورة',
  'Your name': 'اسمك',
  'What should we call you?': 'ماذا يجب أن نسميك؟',
  'First name': 'الاسم الاول',
  'Last name': 'الاسم الأخير',
  'Please enter first name': 'الرجاء إدخال الاسم الأول',
  'Please enter last name': 'الرجاء إدخال الاسم الآخير',
  'Please enter your nickname': 'الرجاء إدخال اسمك المستعار',
  'Set a password': 'قم بتعيين كلمة مرور',
  'Please enter new password': 'الرجاء إدخال كلمة المرور الجديدة',
  'Set success': 'تعيين النجاح',
  'Log in success': 'النجاح في تسجيل الدخول',
  'Click "<span>Open UPDF</span>" in the above dialog box above to log into your account.': 'انقر فوق "<span>Open UPDF</span>" في مربع الحوار أعلاه لتسجيل الدخول إلى حسابك.',
  'Can\'t see the dialog box? Click here.': 'ألا تستطيع رؤية مربع الحوار؟ انقر هنا.',
  'Account center': 'مركز الحساب',
  'Account Center': 'مركز الحساب',
  'Account': 'الحساب',
  'Personal info': 'معلومات شخصية',
  'Photo': 'الصور',
  'Preferred name': 'اسم العرض',
  'Email-2': 'البريد الإلكتروني',
  'UID': 'UID',
  'Mobile phone': 'الهاتف المحمول',
  'Country': 'الدولة',
  'Linked Accounts Manage': 'إدارة الحسابات المرتبطة',
  'Select country': 'حدد الدولة',
  'Your Plans of UPDF': 'خططك لـ UPDF',
  'Upgrade to UPDF Pro to get full access to all features without limits.': 'قم بالترقية إلى UPDF Pro لتحصل على وصول كامل إلى جميع الميزات بلا حدود.',
  'Subscriptions': 'الاشتراكات',
  'You can manage you plan in Apple ID settings': 'يمكنك إدارة خطتك في إعدادات Apple ID',
  'Free': 'مجاني',
  'Annual': 'سنوي',
  'Monthly': 'شهري',
  'Quarterly': 'ربعي',
  'Perpetual': 'دائم',
  'Giveaway': 'الهبة',
  'Cancel subscription': 'إلغاء الاشتراك',
  'Current Plan': 'الخطة الحالية',
  'Renews': 'يجدد',
  'Expire on': 'تنتهي صلاحيته',
  'VIP Duration': 'مدة VIP',
  'Month': 'شهر',
  'Months': 'أشهر',
  'Activate': 'تفعيل',
  'Use Across Devices': 'استخدم عبر الأجهزة',
  'As you already have a subscription plan, activating the "Giveaway" plan would make both plans run on your account, but it will not increase the original subscription time. Are you sure you want to activate the "Giveaway" plan?': 'نظرًا لأن لديك خطة اشتراك بالفعل، فإن تنشيط خطة "الهبة" سيؤدي إلى تشغيل كلا الخطتين على حسابك، ولكنه لن يؤدي إلى زيادة وقت الاشتراك الأصلي. هل أنت متأكد أنك تريد تفعيل خطة "الهبة"؟',
  'Activate the "Giveaway" plan': 'تفعيل خطة "الهبة".',
  'Password management': 'إدارة كلمة المرور',
  'You can set password if you don\'t prefer logging in with codes.': 'يمكنك تعيين كلمة المرور إذا كنت لا تفضل تسجيل الدخول باستخدام الرموز.',
  'Change Password': 'تغيير كلمه المرور',
  'Set Password': 'ضبط كلمة السر',
  'Are you sure log out your account?': 'هل أنت متأكد من تسجيل الخروج من حسابك؟',
  'Log out of UPDF account': 'تسجيل الخروج من حساب UPDF',
  'You may not be able to use all features after logging out of your account until you log back in.': 'قد لا تتمكن من استخدام جميع الميزات بعد تسجيل الخروج من حسابك حتى تقوم بتسجيل الدخول مرة أخرى.',
  'Log Out': 'خروج',
  'Confirm input error': 'تأكيد خطأ الإدخال',
  'Permanently delete your personal information and all data, this operation can\'t be recovered. Enter <span style="color: var(--el-color-primary)">{uid}</span> to confirm the operation.': 'قم بحذف معلوماتك الشخصية وجميع البيانات نهائيًا، ولا يمكن استرداد هذه العملية. أدخل <span style="color: var(--el-color-primary)">{uid}</span> لتأكيد العملية.',
  'Delete your account': 'حذف حسابك',
  'Your personal information and all data will be removed permanently and can\'t be recovered.': 'ستتم إزالة معلوماتك الشخصية وجميع البيانات نهائيًا ولا يمكن استعادتها.',
  'Delete': 'حذف',
  'The avatar must be an image.': 'الصورة الرمزية يجب أن تكون صورة.',
  'You will miss the following membership rights when the subscription expired.': 'ستفقد حقوق العضوية التالية عند انتهاء الاشتراك.',
  'Expire on {date}': 'تنتهي في{date}',
  'Redeem': 'يسترد',
  'Redeem-2': 'يسترد',
  'The license will be bound to your account, and extend the expiration date.': 'سيتم ربط الترخيص بحسابك، وتمديد تاريخ انتهاء الصلاحية.',
  'Please input license.': 'الرجاء إدخال الترخيص.',
  'Incorrect license code.': 'رمز الترخيص غير صحيح.',
  'Redeem success.': 'تخليص النجاح.',
  'Use across Windows, macOS, Android, iOS++No watermark++All annotate tools++Edit PDF text, images and links++Convert PDF to Word, Excel, PPT++OCR Text Recognition++Extract, insert, replace, split pages++Free updates and upgrades': 'استخدمه عبر أنظمة التشغيل Windows و macOS و Android و iOS++ لا توجد علامة مائية تجريبية++ جميع أدوات التعليقات التوضيحية++ تحرير نصوص PDF والصور والروابط++ تحويل PDF إلى Word و Excel و PPT++ التعرف على النص +++ إعادة ترتيب الصفحات وتدويرها واستخراجها وإدراجها وتقسيمها++ تحديثات وترقيات مجانية',
  'Keep UPDF Pro': 'احتفظ بـ UPDF Pro',
  'Continue Cancellation': 'متابعة إلغاء الاشتراك',
  'Renew': 'تجديد',
  'Activate Subscription': 'تفعيل الاشتراك',
  'Success! Your UPDF PRO subscription will be renewed on {date}': 'نجاح! سيتم تجديد اشتراكك في UPDF Pro في {date}',
  'Upgrade to Pro': 'الترقية إلى Pro',
  'Please enter the new mobile phone number': 'الرجاء إدخال رقم الهاتف المحمول الجديد',
  'Please enter a valid mobile phone number': 'يرجى إدخال رقم هاتف صحيح',
  'Please enter a new email address': 'الرجاء إدخال عنوان بريد إلكتروني جديد',
  'Please enter a valid email address-2': 'الرجاء إدخال عنوان بريد إلكتروني مفعل',
  'Verification code error': 'خطأ في رمز التحقق',
  'Set': 'تعيين',
  'Change': 'تغيير',
  'Link': 'الوصلة',
  'Unlink': 'إلغاء الوصلة',
  'not set': 'غير مضبوط',
  'not set-2': 'غير متصلة',
  'Phone Number': 'رقم الهاتف',
  'Google': 'Google',
  'Apple ID': 'Apple ID',
  'Set Phone Number': 'ضبط رقم الهاتف',
  'Please enter the phone number and verification code.': 'الرجاء إدخال رقم الهاتف ورمز التحقق.',
  'Set Email': 'ضبط البريد الإلكتروني',
  'Please enter the email and verification code.': 'الرجاء إدخال البريد الإلكتروني ورمز التحقق.',
  'Please enter the phone number': 'الرجاء إدخال رقم الهاتف',
  'Please enter your email': 'رجاءا أدخل بريدك الإلكتروني',
  'Verification code': 'رمز التحقق',
  'Send code': 'إرسال رمز التحقق',
  'Resend-2': 'ارسل مره ثانيه',
  'please enter the verification code': 'الرجاء إدخال رمز التحقق',
  'Please use wechat to scan the QR code and follow the official account binding': 'يُرجى مسح رمز الاستجابة السريعة الخاص ب Wechat واتباع الحساب الرسمي لربط حسابك',
  'To keep your account safe': 'للحفاظ على أمان حسابك',
  'Please enter the verification code sent to': 'الرجاء إدخال رمز التحقق المرسل إلى',
  'Linked Accounts': 'حسابات متصلة',
  'Binding success': 'تم التوصيل بنجاح',
  'linked': 'متصلة',
  'Unbind successfully': 'تم إلغاء الاتصال بنجاح',
  'Unbinding failure': 'فشل إلغاء الاتصال',
  'Are you sure you want to untie them': 'هل أنت متأكد أنك تريد إلغاء توصيلها؟',
  'UCloud Expires On': 'تنتهي صلاحية UPDF Cloud',
  'UPDF Plan': 'UPDF Pro',
  'Full access to all UPDF features and UCloud benefits.': 'الوصول الكامل إلى جميع ميزات UPDF وفوائد UPDF Cloud.',
  'Full access to all UPDF features and comes with 1-year UCloud benefits.': 'الوصول الكامل إلى جميع ميزات UPDF ويأتي مع مزايا UPDF Cloudلمدة عام واحد.',
  'Upgrade to UPDF Pro to get all UPDF features and UCloud benefits.': 'قم بالترقية إلى UPDF Pro للحصول على جميع ميزات UPDF ومزايا UPDF Cloud.',
  'Full access to all UPDF features.': 'الوصول الكامل إلى كافة ميزات UPDF.',
  'Create a Company': 'إنشاء شركة',
  'Please fill in the company information': 'يرجى ملء معلومات الشركة',
  'Company Name': 'اسم الشركة',
  'Industry Type': 'نوع الصناعة',
  'Number of Employees': 'عدد الموظفين',
  'Set up enterprise account': 'إعداد حساب المؤسسة',
  'Confirm your enterprise account. You will become the administrator with full management rights.': 'قم بتأكيد حساب مؤسستك. سوف تصبح المسؤول مع حقوق الإدارة الكاملة.',
  'Email Address': 'عنوان البريد الإلكتروني',
  'Email Address or Phone Number': 'عنوان البريد الإلكتروني أو رقم الهاتف',
  'Please enter the password of {companyName}': 'الرجاء إدخال كلمة المرور الخاصة بـ {companyName}',
  'Your company is created successfully.': 'تم إنشاء شركتك بنجاح.',
  'Invite members to join the company by email or by copying the link.': 'قم بدعوة الأعضاء للانضمام إلى الشركة عن طريق البريد الإلكتروني أو عن طريق نسخ الرابط ومشاركته.',
  'Invite members': 'دعوة أعضاء',
  'Invite Later': 'الدعوة لاحقاً',
  'Send Invitation': 'إرسال دعوة',
  'Copy Link': 'نسخ الرابط',
  'UPDF PRO': 'UPDF Pro',
  'Your account now has full access to all features without limits.': 'يتمتع حسابك الآن بإمكانية الوصول الكامل إلى جميع الميزات بلا حدود.',
  'Your account has not been authorized by the administrator': 'لم يتم ترخيص حسابك من قبل المسؤول',
  'All': 'الجميع',
  'Authorized': 'مصرح به',
  'Unauthorized': 'غير مصرح',
  'Company Logo': 'شعار الشركة',
  'Contact Information': 'معلومات الاتصال',
  'Administrator': 'مسؤول',
  'Email-1': 'البريد الإلكتروني',
  'Phone Number-1': 'رقم الهاتف',
  'Transfer': 'نقل',
  'Permanently delete your company information and all data, this operation can not be recovered. Enter <span style="color: var(--el-color-primary)">{companyId}</span> to confirm the operation.': 'حذف معلومات شركتك وجميع البيانات نهائيًا، ولا يمكن استرداد هذه العملية. أدخل <span style="color: var(--el-color-primary)">{companyId}</span> لتأكيد العملية.',
  'Assigned': 'مُكَلَّف',
  'Quick Entry': 'دخول سريع',
  'Last Login Time': 'آخر وقت لتسجيل الدخول',
  'Operation': 'عملية',
  'Search': 'بحث',
  'Link copied': 'تم نسخ الرابط',
  'Email, separated by enter': 'البريد الإلكتروني، مفصولة بإدخال',
  'This email is already on the list': 'هذا البريد الإلكتروني موجود بالفعل في القائمة',
  'Invalid Invite Code': 'رمز الدعوة غير صالح',
  'You have joined the company.': 'لقد انضممت إلى الشركة.',
  'The following accounts are bound to the current login method. Please select the account to log in.': 'الحسابات التالية مرتبطة بطريقة تسجيل الدخول الحالية. الرجاء تحديد الحساب لتسجيل الدخول.',
  'Enter password': 'أدخل كلمة المرور',
  'Please enter the password of <span>{username}</span>': 'الرجاء إدخال كلمة المرور لـ <span>{username}</span>',
  'This account is already logged in': 'تم تسجيل الدخول لهذا الحساب بالفعل',
  'You have successfully joined {companyName}': 'لقد انضممت بنجاح إلى {companyName}',
  'Download UPDF now to share membership benefits': 'قم بتنزيل UPDF الآن لمشاركة مزايا العضوية',
  'Download UPDF': 'تحميل UPDF',
  'Please Enter..': 'رجاء ادخل..',
  'Full Name': 'الاسم الكامل',
  'Please login first': 'الرجاء تسجيل الدخول أولا',
  'administrator': 'مسؤول',
  'Dissolve Company': 'حل الشركة',
  'Permanently delete your business information and data. This action is non-recoverable. Enter <span style="color: var(--el-color-primary)">{companyId}</span> to confirm.': 'الحذف الدائم لمعلومات وبيانات شركتك لا يمكن استعادتها. أدخل <span style="color: var(--el-color-primary)">{companyId}</span> للتأكيد.',
  'Accommodation and Food Services': 'خدمات الإقامة والطعام',
  'Administration, Business Support, and Waste Management Services': 'الإدارة ودعم الأعمال وخدمات إدارة النفايات',
  'Agriculture, Forestry, Fishing, and Hunting': 'الزراعة والغابات وصيد الأسماك والقنص',
  'Arts, Entertainment, and Recreation': 'الفنون والترفيه والترفيه',
  'Construction': 'الإنشاءات',
  'Educational Services': 'خدمات تعليمية',
  'Finance and Insurance': 'التمويل والتأمين',
  'Healthcare and Social Assistance': 'الرعاية الصحية والمساعدة الاجتماعية',
  'Information and Communication': 'المعلومات والاتصالات',
  'Manufacturing': 'تصنيع',
  'Mining': 'التعدين',
  'Other Services': 'خدمات أخرى',
  'Professional, Scientific, and Technical Services': 'الخدمات المهنية والعلمية والتقنية',
  'Real Estate, Rental, and Leasing': 'العقارات والتأجير والتأجير',
  'Wholesale and Retail Trade': 'تجارة الجملة والتجزئة',
  'Transportation and Warehousing': 'النقل والتخزين',
  'Utilities': 'خدمات',
  'Order No.': 'رقم الطلب',
  'Amount': 'كمية',
  'Product': 'منتج',
  'Payment Time': 'وقت الدفع',
  'Payment Status': 'حالة السداد',
  'Your order is being processed. It may take from 2 to 6 working days to process your payment using the payment method of Sofort/Pix/Boleto. You will be informed via email once the process is done.': 'طلبك قيد المعالجة. قد يستغرق الأمر ما بين 2 إلى 6 أيام عمل لمعالجة عملية الدفع الخاصة بك باستخدام إحدى طرق الدفع التالية Sofort/Pix/Boleto. سيتم إبلاغك عبر البريد الإلكتروني بمجرد الانتهاء من العملية.',
  'Unpaid': 'غير مدفوعة',
  'Failure': 'فشل',
  'Paid': 'مدفوع',
  'Refunded': 'ردها',
  'Pending': 'قيد الانتظار',
  'Expire on:': 'تنتهي صلاحيته في:',
  'Card Expired': 'انتهت صلاحية البطاقة',
  'The payment card can only be changed for orders under subscription. For canceled orders, the renewal has been cancelled, and the payment card cannot be changed. If you need to change the payment card, please renew the subscription of this order in "Subscriptions" first.': 'لا يمكن تغيير بطاقة الدفع إلا لطلبات الاشتراك السارية. بالنسبة للطلبات الملغاة، تم إلغاء التجديد، ولا يمكن تغيير بطاقة الدفع. إذا كنت بحاجة إلى تغيير بطاقة الدفع، يُرجى تجديد الاشتراك لهذا الطلب في ”الاشتراكات“ أولاً.',
  'Canceled': 'تم الإلغاء',
  'Change Card': 'تغيير البطاقة',
  'Active': 'نشيط',
  'Inactive': 'غير نشط',
  'Credit cards associated with subscription orders can be managed here. Here you can modify the credit card that will be used for future renewals. To cancel or restore a subscription, please operate in "Subscriptions".': 'يمكن هنا إدارة بطاقات الائتمان المرتبطة بأوامر الاشتراك. هنا يمكنك تعديل بطاقة الائتمان التي سيتم استخدامها للتجديدات المستقبلية. لإلغاء الاشتراك أو استعادته، يرجى التشغيل في "الاشتراكات".',
  'Security': 'الأمن',
  'Payment Management': 'إدارة الدفع',
  'Order Information': 'معلومات الطلب',
  'Pay Again': 'ادفع مرة أخرى',
  'Change successfully': 'التغيير بنجاح',
  'Change failed, please try again': 'فشل التغيير، يرجى المحاولة مرة أخرى',
  'Order information only includes orders purchased through the website. Applepay and Google Play orders will not be displayed.': 'تتضمن معلومات الطلبات فقط الطلبات التي تم شراؤها من خلال الموقع الإلكتروني. لن يتم عرض طلبات Apple Pay و Google Play.',
  'Membership': 'عضوية',
  '(Educational)': '(تعليمي)',
  'Issue an invoice': 'إصدار فاتورة',
  'Download invoice': 'تحميل فاتورة',
  'Bill To:': 'مشروع قانون ل:',
  'Name': 'اسم',
  'Address': 'عنوان',
  'ZIP Code': 'الرمز البريدي',
  'Submit': 'يُقدِّم',
  'Please check the information carefully. It cannot be modified after submission. Are you sure to submit?': 'يرجى التحقق من المعلومات بعناية. لا يمكن تعديلها بعد الإرسال. هل أنت متأكد من الإرسال؟',
  'Are you sure?': 'هل أنت متأكد؟',
  'Invoice Information': 'معلومات الفاتورة',
  'Must enter 1-20 characters': 'يجب إدخال 1-20 حرفًا',
  'Must enter 1-100 characters': 'يجب إدخال 1-100 حرفًا',
  'Must enter 1-500 characters': 'يجب إدخال 1-500 حرفًا',
  'Must enter 1-200 characters': 'يجب إدخال 1-200 حرفًا',
  'Must enter 1-50 characters': 'يجب إدخال 1-50 حرفًا',
  'Device Management': 'إدارة الجهاز',
  'Desktop': 'سطح المكتب',
  'Last active': 'آخر نشاط',
  'Login out': 'الخروج',
  'Mobile': 'متحرك',
  'After being removed, the device will automatically log out and needs to be logged in again. Do you confirm the operation?': 'بعد إزالته، سيتم تسجيل خروج الجهاز تلقائيًا ويحتاج إلى تسجيل الدخول مرة أخرى. هل تؤكد العملية؟',
  'Settings': 'إعدادات',
  'Avatar': 'الصورة الرمزية',
  'Sign Out': 'خروج',
  'Join Time': 'انضم الي الوقت',
  'Remove Member': 'ازاله العضو',
  'Deauthorize': 'الغاء التفويض',
  'Authorize': 'تفويض',
  'Authorization': 'التفويض',
  'Company Overview': 'نبذه عن الشركة',
  'Redeem-3': 'استرداد',
  'Buy Licenses': 'شراء الترخيص',
  'Member Management': 'اداره الاعضاء',
  'Deleted Successfully': 'حذف بنجاح',
  'Deauthorized Successfully': 'تم إلغاء التفويض بنجاح',
  'Authorized Successfully': 'تم التفويض بنجاح',
  'Redeemed successfully': 'تم الاسترداد بنجاح',
  'Company Settings': 'اعدادات الشركة',
  'Company Infomation': 'معلومات الشركة',
  'The invitation has been sent successfully': 'تم ارسال الدعوه بنجاح',
  'Incorrect format of email': 'تنسيق البريد الالكتروني غير صحيح',
  'Incorrect format of phone number': 'تنسيق غير صحيح لرقم الهاتف',
  'Dissolved successfully': 'تم الذوبان بنجاح',
  'License View': 'لوحة معلومات ترخيص المؤسسة',
  'Member View': 'عرض الآعضاء',
  'Total Licenses': 'اجمالي التراخيص',
  'Total Members': 'اجمالي الأعضاء',
  'Reset': 'اعاده ضبط',
  'Number of Members': 'عدد من أعضاء',
  'Company ID': 'هوية الشركة',
  'No staff selected': 'لم يتم اختيار أي موظف',
  'Please enter the email': 'الرجاء ادخال البريد الالكتروني',
  'Add Member': 'اضافه عضو',
  'Please enter the company name': 'الرجاء ادخال اسم الشركة',
  'Permanently delete your business information and data. This action is non-recoverable.': 'الحذف الدائم لمعلومات وبيانات شركتك لا يمكن استعادتها.',
  'Skip': 'تخطي',
  'You are not an administrator and do not have permission to access this page.': 'آنت لست مسؤولا وليس لديك اذن للوصول الى هذه الصفحة.',
  'Enterprise management': 'اداره المؤسسة',
  'Flexible configuration, tracking, and management of licenses within your company.': 'تكوين مرن للتراخيص وتتبعها وادارتها داخل شركتك',
  'Enterprise management dashboard': 'لوحه تحكم اداره المؤسسة',
  'Authorization failed': 'فشل التفويض',
  'Buy Now': 'اشتر الان',
  'Buy': 'اشتر',
  'Insufficient licenses available! Want to buy more licenses?': 'التراخيص غير كافيه المتاحة! هل تريد شراء المزيد من التراخيص؟',
  'Privilege grant failed': 'فشل المصرح به',
  'Number of Users': 'عدد المستخدمين',
  'Member Avatar': 'الصورة الرمزية للأعضاء',
  'Password must be 6-20 characters, and should have numbers, English letters, or symbols.': 'جب أن تتكون كلمة المرور من 6 إلى 20 حرفًا، ويجب أن تحتوي على أرقام أو أحرف إنجليزية أو رموز.',
  'Not set': 'غير مضبوط',
  'The current account is the administrator of {companyName}, please log in to the enterprise management platform and dissolve the company to complete the deletion.': 'الحساب الحالي هو المسؤول عن {companyName}. لحذف الحساب، يرجى تسجيل الدخول إلى لوحة معلومات إدارة المؤسسة وحل الشركة.',
  'Permanently and irreversibly delete the member\'s account and all data. Click OK to complete the deletion': 'لا يمكن استرداد الحذف الدائم لحساب العضو وبياناته. انقر فوق موافق لتأكيد الحذف.',
  'Got it': 'حصلت عليها',
  'CompanyId Error': 'خطأ في هوية الشركة',
  'Select': 'يختار',
  'Enterprise management background': 'خلفيه اداره المؤسسة',
  'Authorized employees': 'الموظفون المفوضون',
  'Authorized members': 'الأعضاء المفوضون',
  'The current account already has a perpetual plan. If you need to redeem it again, please change to another account.': 'الحساب الحالي لديه بالفعل خطة دائمة. إذا كنت بحاجة إلى استخدام رمز الاسترداد، يرجى التغيير إلى حساب آخر.',
  'Number of redemption licences': 'عدد تراخيص الاستيراد',
  'Invalid redemption code': 'رمز الاسترداد غير صالح',
  'Allocation of Licence Quotas (Number of employees with licences/Total number of licences)': 'تخصيص حصص التراخيص (عدد الموظفين الحاصلين على تراخيص / إجمالي عدد التراخيص)',
  'Authorization of Employee Status (Number of employees with licences/Total number of employees)': 'تصريح حالة الموظف (عدد الموظفين الحاصلين على تراخيص / إجمالي عدد الموظفين)',
  'All the selected enterprise users will be permanently deleted. Do you want to continue?': 'سيتم حذف جميع مستخدمي المؤسسة المحددين بشكل دائم. هل أنت متأكد من المتابعة؟',
  'Share Invitation': 'مشاركه الدعوة',
  'Add Manually': 'اضافه يدويا',
  'Batch Import': 'استيراد دفعه',
  'Export All Member': 'تصدير جميع الأعضاء',
  'Export Selected Member': 'تصدير الأعضاء المختارين',
  'Account: required. 6-60 characters. The account can not be repeated. It supports numbers, English letters and English symbols.': 'الحساب: هذا الحقل مطلوب. يجب أن يتكون من 6 إلى 60 حرفًا، ولا يمكن تكراره، ويدعم الأرقام والحروف الإنجليزية والرموز الإنجليزية.',
  'Name: required. The length is limited to 60 characters.': 'الاسم: مطلوب. يقتصر الطول على 60 حرفًا.',
  'Password: optional. 6-20 characters. It supports numbers, English letters and English symbols.': 'كلمة المرور: هذا الحقل اختياري. من 6 إلى 20 حرفاً ويمكن أن تتضمن أرقاماً وحروفاً إنجليزية ورموزاً إنجليزية.',
  'Mobile phone number: optional. Phone number format.': 'رقم الهاتف المحمول: هذا الحقل اختياري. تنسيق رقم الهاتف.',
  'Whether to authorize: optional. Please fill in [Yes], [No]. If not filled, the default is [No].': 'ما إذا كان سيتم التفويض: اختياري. يرجى ملء [نعم]، [لا]. إذا لم يتم ملؤه، فإن الإعداد الافتراضي هو [لا].',
  'Uploaded Failed': 'فشل التحميل',
  'The content is wrong. Please modify and reupload.': 'المحتوى خاطئ. يرجى التعديل وإعادة الرفع.',
  'Uploaded Succeed!': 'تم التحميل بنجاح',
  'Employee Table Template.xlsx': 'قالب جدول الموظف.xlsx',
  'You can click to download the Employee table template and fill out the table': 'يمكنك النقر لتنزيل قالب جدول الموظفين وملء الجدول',
  'Copy the following information and notify the user to log in.': 'انسخ المعلومات التالية وأخطر المستخدم بتسجيل الدخول.',
  'Must be letters, digits or symbols': 'يجب أن تكون حروفًا أو أرقامًا أو رموزًا',
  'Please contact administrator to reset password': 'يرجى الاتصال بالمسؤول لإعادة تعيين كلمة المرور',
  'Please enter account/email/phone number': 'الرجاء إدخال الحساب/البريد الإلكتروني/رقم الهاتف',
  'Please enter an effective account/email/phone number': 'الرجاء إدخال رقم الحساب/البريد الإلكتروني/الهاتف الفعال',
  'Please enter account/email': 'الرجاء إدخال الحساب/البريد الإلكتروني',
  'Please enter an effective account/email': 'الرجاء إدخال حساب/بريد إلكتروني فعال',
  'Drag the template here, or <em>click to upload</em>': 'اسحب القالب هنا، أو <em>انقر للتحميل</em>',
  'Account_1': 'حساب',
  'Inactivated': 'معطل',
  'Activated': 'مفعل',
  'Deleted': 'محذوف',
  'Register & log in UPDF account You can convert <span>2 files for FREE</span>': 'من خلال التسجيل وتسجيل الدخول إلى حساب UPDF، يمكنك تحويل <span>ملفين مجانًا</span>',
  'Register & log in UPDF account You can convert <span>2 files per day</span>for FREE': 'من خلال التسجيل وتسجيل الدخول إلى حساب UPDF، يمكنك تحويل <span>ملفين يوميًا</span> مجانًا',
  '{{.shareName}} added you to {{.companyName}}': 'أضافك {{.shareName}} إلى {{.companyName}}',
  '{{.shareName}} added you to {{.companyName}}. You can share UPDF membership benefits now. The account information is as follows. Remember to save it and log in.': 'أضافك {{.shareName}} إلى {{.companyName}}. يمكنك مشاركة مزايا عضوية UPDF الآن. معلومات الحساب هي كما يلي. تذكر أن تقوم بحفظه وتسجيل الدخول.',
  'Password': 'كلمه المرور',
  'Full name': 'الاسم كامل',
  'Your password has been reset': 'تم إعادة تعيين كلمة المرور الخاصة بك',
  'Your password has been reset by the administrator. The account information is as follows. Remember to save it and log in.': 'تمت إعادة تعيين كلمة المرور الخاصة بك من قبل المسؤول. يرجى العثور على معلومات حسابك في الأسفل. تذكر أن تحفظها وتستخدمها لتسجيل الدخول.',
  'Upload the filled out template:': 'قم بتحميل النموذج المملوء:',
  'Please enter account': 'الرجاء إدخال الحساب',
  'Please enter password': 'الرجاء إدخال كلمة المرور',
  'Must enter 6-20 characters': 'يجب إدخال 6-20 حرفا',
  'Please enter 1-30 characters': 'الرجاء إدخال 1-30 حرفا',
  'Must enter 1-30 characters': 'يجب إدخال 1-30 حرفًا',
  'Please enter email': 'الرجاء إدخال البريد الإلكتروني',
  'Please enter an effective email': 'الرجاء إدخال بريد إلكتروني صحيح',
  'Please enter phone number': 'الرجاء إدخال رقم الهاتف',
  'Copy': 'نسخ',
  'Only one file can be uploaded': 'يمكن تحميل ملف واحد فقط',
  'Accounts can not be repeated. Only numbers, letters, and symbols are supported; it is recommended to name accounts with numbers or letters plus a company suffix (for example: abc@updf, 0100@updf) to ensure uniqueness.': 'لا يمكن تكرار أسماء الحسابات. يتم دعم الأرقام والحروف والرموز فقط. يوصى بتسمية الحسابات بأرقام أو حروف بالإضافة إلى لاحقة الشركة (على سبيل المثال: abc@updf، 0100@updf) لضمان التفرد.',
  'Reason of failure:': 'أسباب فشل الاستيراد',
  'Information copied': 'تم نسخ المعلومات',
  'Message sent': 'تم الارسال',
  'The file can not exceed 10MB': 'لا يمكن أن يتجاوز الملف 10 ميغابايت',
  'Must enter 6-60 characters': 'يجب إدخال 6-60 حرفًا',
  'The file exceeds the limit of 30,000 lines, please modify and upload again': 'يتجاوز الملف الحد الأقصى وهو 30000 سطر، يرجى التعديل والتحميل مرة أخرى',
  'Support format': 'تنسيق الدعم',
  'Send a message to notify the user to log in': 'إرسال رسالة لإعلام المستخدم بتسجيل الدخول',
  'Please enter email/phone number': 'الرجاء إدخال البريد الإلكتروني/رقم الهاتف',
  'Please enter an effective email/phone number': 'الرجاء إدخال بريد إلكتروني/رقم هاتف/بريد إلكتروني صالح',
  'Added successfully': 'اضيف بنجاح',
  'Member Info': 'معلومات العضو',
  'Send': 'إرسال',
  'The company name only supports Chinese characters': 'اسم الشركة يدعم الحروف الصينية فقط',
  'http_error_4023': 'رمز الاسترداد مخصص للمؤسسات. يرجى الانتقال إلى لوحة تحكم إدارة المؤسسات لاسترداده.',
  'E-mail: optional. Email format.': 'البريد الإلكتروني: اختياري. تنسيق البريد الإلكتروني. لا يمكن تكراره.',
  'Phone number: optional. Phone number format.': 'رقم الهاتف: اختياري. تنسيق رقم الهاتف. لا يمكن تكراره.',
  'Enterprise name': 'اسم المؤسسة',
  'Redeem Now': 'استرد الان',
  'Auto-redemption': 'الاسترداد التلقائي',
  'You have purchased the Enterprise Plan. Do you want to auto-redeem your plan?': 'لقد قمت بشراء خطة المؤسسة. هل تريد استرداد خطتك تلقائيًا؟',
  'Later': 'لاحقا',
  'Redemption code': 'رمز التأكيد',
  'Users': 'المستخدمين',
  'It is an enterprise license code, please go to Enterprise Management Dashboard to redeem it.': 'رمز الاسترداد مخصص للمؤسسات. يرجى الانتقال إلى لوحة تحكم إدارة المؤسسات لاسترداده.',
  'Open UPDF': 'افتح UPDF',
  'Personal Account': 'الحساب الفردي',
  'Enterprise Account': 'حساب المؤسسة',
  'Language Settings': 'اعدادات اللغة',
  'Language': 'لغة',
  'Click "Open UPDF" to automatically log in to the enterprise account.': 'انقر فوق "فتح UPDF" لتسجيل الدخول تلقائيًا إلى حساب المؤسسة.',
  'Click "Enterprise Management Dashboard", you can enter the Management Dashboard to redeem plan, set enterprise information, invite members to join the enterprise, and conduct enterprise management.': 'انقر فوق "لوحة تحكم إدارة المؤسسة"، ويمكنك الدخول إلى لوحة تحكم الإدارة لاسترداد الخطة، وتعيين معلومات المؤسسة، ودعوة الأعضاء للانضمام إلى المؤسسة، وإجراء إدارة المؤسسة.',
  'Company': 'شركه',
  'Please enter your purchased UPDF redemption code, the successful redemption will increase the number of authorized licenses for the company.': 'يرجى إدخال رمز استرداد UPDF الذي اشتريته، وسيؤدي الاسترداد الناجح إلى زيادة عدد التراخيص المعتمدة للشركة.',
  'Click to Accept': 'انقر للقبول',
  'Dissolve success': 'حل النجاح',
  'Upload files up to 100 per month': 'تحميل ملفات تصل إلى 100 شهريا',
  'Up to 1000 pages per file': 'ما يصل إلى 1000 صفحة لكل ملف',
  'Ask questions up to 1000 times per month': 'اطرح الأسئلة حتى 1000 مرة شهريًا',
  'Up to 2GB per file': 'ما يصل إلى 2 جيجابايت لكل ملف',
  '10GB of FREE ADDITIONAL STORAGE': '10 جيجابايت من التخزين السحابي',
  'You have unlocked advanced AI features': 'لقد قمت بفتح ميزات AI المتقدمة',
  'UPDF AI Pro Plan': 'مساعد AI',
  'Upgrade': 'ترقية',
  'Upgrade to UPDF AI Pro monthly Plan to unlock more AI features': 'الترقية إلى خطة مساعد الذكاء الاصطناعي لفتح المزيد من ميزات الذكاء الاصطناعي',
  'Full access to all UPDF AI features and UPDF Cloud benefits': 'وصول كامل إلى جميع ميزات مساعد AI و UPDF Cloud.',
  'Success! Your UPDF AI PRO subscription will be renewed on {date}': 'نجاح! سيتم تجديد اشتراكك في مساعد AI في {date}',
  'Keep UPDF AI Pro': 'احتفظ بـمساعد AI',
  'Continue with Apple': 'تواصل مع Apple',
  'Continue with Google': 'تواصل مع Google',
  'You can also <span>continue with SSO</span>': 'يمكنك أيضًا <span>متابعة استخدام الدخول الموحَّد (SSO)</span>',
  'Operation successful': 'تمت العملية بنجاح',
  'Operation failed, please try again': 'فشلت العملية، يرجى المحاولة مرة أخرى',
  'Super Admin information': 'معلومات المشرف المتميز',
  'Transfer super Admin': 'نقل المشرف المتميز',
  'Confirm to transfer super Admin?': 'تأكيد نقل المسؤول الفائق؟',
  'You will automatically log out of the management backend interface after the transfer': 'ستقوم بتسجيل الخروج تلقائياً من لوحة معلومات إدارة المؤسسة بعد النقل.',
  'Organization management': 'إدارة المنظمة',
  'Super Admin can add 5 ordinary Admin; ordinary Admin have all the operation rights of the management backend, except the following functions: transfer super Admin; add and remove ordinary Admins; dissolve the company.': 'يمكن للمسؤول المتميز إضافة 5 مسؤولين عاديين؛ ويتمتع المسؤول العادي بجميع حقوق تشغيل الواجهة الخلفية للإدارة، باستثناء الوظائف التالية: نقل المشرفين العاديين؛ وإضافة وإزالة المسؤولين العاديين؛',
  'Add Admin': 'إضافة مسؤول',
  'Admin list': 'قائمة المسؤولين',
  'Please enter the employee\'s account': 'الرجاء إدخال حساب الموظف',
  'Confirm to remove Admin?': 'تأكيد لإزالة المشرف؟',
  'After removal, the employee will not be able to enter the management backend': 'بعد الإزالة، لن يتمكن الموظف من الدخول إلى الواجهة الخلفية للإدارة',
  'Duplicate addition': 'تمت إضافة نسخة مكررة',
  'Super admin cannot be added as a normal admin': 'لا يمكن إضافة المشرفين المتميزين كمسؤولين عاديين',
  'The super admin removes you from the admin of {{.companyName}}. You can continue to use the enterprise account, but you no longer have the authority to manage the enterprise. If you have any questions, please communicate with the super admin in time.': 'يقوم المشرف المتميز بإزالتك من مسؤول {{.companyName}}. يمكنك الاستمرار في استخدام حساب المؤسسة، ولكن لم يعد لديك السلطة لإدارة المؤسسة. إذا كانت لديك أي أسئلة، فيرجى التواصل مع المشرف المتميز في وقت.',
  'The super admin adds you as a admin of {{.companyName}}. You can log in to the enterprise management backend to manage the enterprise. The admin\'s account password is your UPDF enterprise account password.': 'يضيفك المشرف المتميز كمسؤول في {{.companyName}}. يمكنك تسجيل الدخول إلى الواجهة الخلفية لإدارة المؤسسة لإدارة المؤسسة. كلمة مرور حساب المشرف هي كلمة مرور حساب مؤسسة UPDF.',
  '{{.shareName}} transfers the super administrator of {{.companyName}} to you. You can log in to the enterprise management backend to manage the enterprise. The administrator\'s account password is your UPDF enterprise account password.': 'يقوم {{.shareName}} بنقل المسؤول المتميز لـ {{.companyName}} إليك. يمكنك تسجيل الدخول إلى الواجهة الخلفية لإدارة المؤسسة لإدارة المؤسسة. كلمة مرور حساب المسؤول هي كلمة مرور حساب مؤسسة UPDF الخاص بك.',
  'Enterprise management dashboard:': ':لوحه تحكم اداره المؤسسة',
  'Notification of transferring enterprise super admin': 'إشعار بنقل المشرف المتميز للمؤسسة',
  'Notification of adding enterprise admin': 'إشعار بإضافة مسؤول المؤسسة',
  'Notification of removing enterprise admin': 'إشعار بإزالة مسؤول المؤسسة',
  'Administrators cannot be deleted': 'لا يمكن حذف المسؤولين',
  'A maximum of 5 normal administrators can be added': 'يمكن إضافة 5 مسؤولين عاديين كحد أقصى',
  'UPDF AI Unlimited': 'مساعد AI',
  'UPDF AI Standard': 'مساعد AI (قياسية)',
  'UPDF AI Plan': 'مساعد AI',
  'Upload files unlimited per month++Up to 1000 pages per file++Ask questions unlimited times per month++Up to 2GB per file++100GB of FREE ADDITIONAL STORAGE': 'تحميل الملفات بشكل غير محدود شهريًا ++ ما يصل إلى 1000 صفحة لكل ملف ++ طرح الأسئلة مرات غير محدودة شهريًا ++ ما يصل إلى 2 جيجابايت لكل ملف ++ 100 جيجابايت من مساحة التخزين الإضافية المجانية',
  'Success! Your {aiType} subscription will be renewed at {money} on {date}': 'نجاح! سيتم تجديد اشتراكك في {aiType} في {date}',
  'Success! Your UPDF PRO subscription will be renewed at {money} on {date}': 'تم بنجاح! سيتم تجديد اشتراكك في UPDF PRO بمبلغ {money} في تاريخ {date}',
  'Thank you for being with us—enjoy a special offer before you go.': 'شكرًا لوجودك معنا — استمتع بعرض خاص قبل مغادرتك.',
  'Your plan: <span> {planName} </span>': 'خطة اشتراكك: <span> {planName} </span>',
  'Regular price: <span>{planSubscriptionMoney} / {planType}</span> → <span>{planDiscountSubscriptionMoney} / {planType}</span>': 'السعر العادي: <span>{planSubscriptionMoney} / {planType}</span> → <span>{planDiscountSubscriptionMoney} / {planType}</span>',
  'You can still cancel anytime. Would you like to stay at this discounted rate?': 'لا يزال بإمكانك الإلغاء في أي وقت. هل ترغب في الإقامة بهذا السعر المخفض؟',
  'Stay and Save {discount}%': 'البقاء والتوفير {discount}%',
  '{discount}% OFF': '{discount}% خصم',
  'Keep UPDF AI Unlimited': 'حافظ على مساعد AI',
  'Keep UPDF AI Standard': 'حافظ على مساعد AI (قياسية)',
  'Organizational License View': 'لوحة معلومات ترخيص المؤسسة',
  'Unlimited': 'غير محدودة',
  'Your company membership benefits will expire in {organizeExpiredTime} days and all membership benefits will be unavailable. Please contact UPDF sales promptly to renew your membership.': 'ستنتهي صلاحية خطة المؤسسة الخاصة بك في {organizeExpiredTime} من الأيام ولن تكون جميع مزايا العضوية متاحة. يرجى الاتصال بمبيعات UPDF على الفور لتجديد عضويتك.',
  'Your company\'s membership rights have expired and all membership rights are no longer available. Please contact UPDF sales today to renew your membership.': 'انتهت صلاحية خطة المؤسسة الخاصة بك ولم تعد جميع حقوق العضوية متاحة. يرجى الاتصال بفريق مبيعات UPDF اليوم لتجديد عضويتك.',
  'Function Settings': 'إعدادات الوظيفة',
  'Enterprise cloud management': 'إدارة السحابة المؤسسية',
  'Enterprise AI management': 'إدارة الذكاء الاصطناعي للمؤسسات',
  'Turn off': 'أطفأ',
  'Trun on': 'تشغيل',
  'When the function is turned on, employees can use the cloud function; when it is turned off, the cloud function is turned off and employee accounts can only use local files and cannot upload them to the cloud. This feature is enabled by default.': 'عند تشغيلها، يمكن للموظفين استخدام وظيفة السحابة؛ وعند إيقاف تشغيلها، يمكن للموظفين استخدام الملفات المحلية فقط ولا يمكنهم تحميلها إلى السحابة. يتم تشغيل هذه الميزة بشكل افتراضي.',
  'After closing, all Cloud functions under the employee account will be closed, and all files uploaded to the Cloud will be inaccessible. Are you sure?': 'عند إيقاف تشغيل الميزة السحابية، تصبح غير متوفرة، ويتعذر الوصول إلى الملفات التي تم تحميلها. هل أنت متأكد من إيقاف تشغيلها؟',
  'After closing, all Cloud functions under the employee account will be closed, and all files uploaded to the Cloud will be inaccessible. Since the AI function requires the Cloud to be turned on before it can be used, if you turn off the Cloud, the AI switch will be turned off at the same time. Are you sure?': 'عندما يتم إيقاف تشغيل الميزة السحابية، تصبح غير متوفرة، وسيتعذر الوصول إلى الملفات التي تم تحميلها. نظرًا لأن AI يتطلب تشغيل الميزة السحابية، فإن تعطيل الميزة السحابية سيؤدي أيضًا إلى تعطيل AI. هل أنت متأكد من إيقاف تشغيلها؟',
  'Once enabled, all Cloud functions under the employee account will be enabled, and files can be uploaded to Cloud. Are you sure?': 'عند تشغيلها، يمكن للموظفين استخدام ميزة السحابة وتحميل الملفات إلى السحابة. هل أنت متأكد من تشغيلها؟',
  'When the function is turned on, employees can use AI; when it is turned off, the AI function is turned off. This function is a paid function. If you want to use AI, please contact sales': 'عندما تكون ميزة مساعد AI قيد التشغيل، يكون AI متاحاً للاستخدام. عند إيقاف التشغيل، يكون AI غير متاح للاستخدام. إذا لم تقم بشراء أي خطة مساعد AI حتى الآن، فعليك الشراء من صفحة التسعير أو الاتصال بالمبيعات.',
  'After closing, all AI functions under the employee account will be closed, and all generated AI conversation content will be inaccessible. Are you sure?': 'عند إيقاف التشغيل، يصبح مساعد AI غير متاح للموظفين، ولن يمكن الوصول إلى جميع محتويات محادثة AI التي تم إنشاؤها. هل أنت متأكد من إيقاف تشغيله؟',
  'After it is enabled, all AI functions under the employee account will be enabled. Are you sure?': 'عند تشغيله، سيكون مساعد AI متاحاً للموظفين. هل أنت متأكد من تشغيله؟',
  'This function is a paid function. If you want to use AI membership, please contact sales.': 'يتطلب مساعد AI اشتراكاً قبل الاستخدام. إذا لم تكن قد اشتريت خطة مساعد AI حتى الآن، يُرجى زيارة صفحة التسعير أو الاتصال بفريق المبيعات للحصول على المساعدة.',
  'Using the AI ​​function requires uploading documents to the Cloud. Please turn on the Cloud function first before turning on the AI ​​switch.': 'يتطلب استخدام مساعد AI تحميل المستندات إلى السحابة. يرجى تشغيل وظيفة السحابة قبل تشغيل مساعد AI.',
  'I know': 'أنا أعرف',
  'Company User': 'مستخدم الشركة',
  'Company UPDF Licenses': 'تراخيص المؤسسات لـ UPDF',
  'Company AI Licenses': 'تراخيص المؤسسات لمساعد AI',
  'UPDF': 'UPDF',
  'Use Of State': 'حالة الترخيص',
  'Residue': 'المتبقي',
  'More Operations': 'المزيد من العمليات',
  'Buy UPDF Licenses': 'اشتر UPDF Pro',
  'Buy AI Licenses': 'اشتر مساعد AI',
  'UPDF Authorize': 'تفويض UPDF Pro',
  'AI Authorize': 'تفويض مساعد AI',
  'UPDF AI': 'مساعد AI',
  'UPDF Deauthorize': 'إلغاء تفويض UPDF Pro',
  'AI Deauthorize': 'إلغاء تفويض مساعد AI',
  'UPDF AI Authorize': 'تفويض مساعد AI',
  'Approval Management': 'إدارة الموافقة',
  'Order Number': 'رقم الطلب',
  'ProductUPDF': 'المنتج',
  'Number': 'الرقم',
  'Created at': 'تم إنشاؤه في',
  'Payment Method': 'طريقة الدفع',
  'Money': 'المبلغ',
  'Subscription': 'الاشتراك',
  'No Subscription': 'لا يوجد اشتراك',
  'UPDF Lifetime': 'الخطة الدائمة لUPDF',
  'AI Annual': 'الخطة السنوية لمساعد AI',
  'Non payment': 'غير مدفوعة',
  'payment failure': 'فشل الدفع',
  'cancel Subscribing': 'إلغاء الاشتراك',
  'Subscribing': 'الاشتراك',
  'Orders': 'الطلبات',
  'Create a personal account': 'إنشاء حساب شخصي',
  'CompanyAccount': 'الحساب',
  'Unauthorized employee': 'موظف غير مصرح له',
  'Authorized employee': 'موظف مصرح له',
  'Order': 'الطلب',
  'Amount of AI plans to be redeemed': 'عدد خطط AI المطلوب استردادها',
  'Amount of UPDF plans to be redeemed': 'عدد خطط UPDF المطلوب استردادها',
  'Pay time': 'وقت الدفع',
  'Quantity': 'الكمية',
  'Payment status': 'حالة السداد',
  'Active Status': 'الحالة النشطة',
  'Insufficient licenses available！Please contact sales.': 'التراخيص غير كافية! يرجى زيارة صفحة الأسعار للشراء أو الاتصال بالمبيعات للحصول على المساعدة.',
  'Please contact the administrator to obtain authorization so that you can use advanced features.': 'يُرجى الاتصال بالمسؤول لطلب تفويض للوصول إلى الميزات المتقدمة.',
  'Administrator Information': 'معلومات المسؤول',
  'Transfer Administrator': 'مسؤول التحويلات',
  'Are you sure to transfer the administrator?': 'هل أنت متأكد من نقل المسؤول؟',
  'You will be automatically logged out of the Enterprise Management Dashboard after transfering the administrator. The new administrator can directly log in Management Dashboard through his account and password.': 'سيتم تسجيل الخروج تلقائياً من لوحة معلومات إدارة المؤسسة بعد نقل المسؤول. يمكن للمسؤول الجديد تسجيل الدخول مباشرة إلى لوحة معلومات الإدارة من خلال حسابه وكلمة المرور الخاصة به.',
  'Account binding': 'حسابات الوصلة',
  'Please enter your email address and verification code': 'الرجاء إدخال عنوان البريد الإلكتروني و رمز التحقق',
  'Please input your email': 'الرجاء إدخال بريدك الإلكتروني',
  'Invalid verification code, please try again': 'رمز تحقق غير صحيح, الرجاء المحاولة مرة اخرى',
  'Current version': 'الاصدار الحالي',
  'Check for upgrades': 'تحقق من وجود تحديثات',
  'The current version is already the latest version': 'الاصدار الحالي هو احدث اصدار بالفعل',
  'Upgrade immediately': 'الترقية على الفور',
  'Send verification code': 'إرسال رمز التحقق',
  'Account or password error': 'خطأ في الحساب او كلمة المرور',
  'Please contact the administrator to reset the password': 'الرجاء التواصل مع المدير لإعادة ضبط كلمة المرور',
  'Please enter the administrator\'s email': 'الرجاء إدخال البريد الإلكتروني للمدير',
  'Please enter the 4-digit verification code sent to {account}. <br>Valid for 10 minutes.': 'الرجاء إدخال 4 ارقام رمز التحقق المُرسلة الى account}. <br> صالح لمدة 10 دقائق.',
  'Private Enterprise Account': 'حساب المؤسسة الخاص',
  'This software is about to be downloaded to the server, are you sure?': 'سيتم تنزيل هذا البرنامج على الخادم. هل أنت متأكد؟',
  'The server will be upgraded, are you sure?': 'ستتم ترقية الخادم. هل أنت متأكد؟',
  'Confirm Upgrade': 'تأكيد الترقية',
  'Checking...': 'التحقق من...',
  'Server Upgrade': 'ترقية الخادم',
  'Software Upgrade': 'ترقية البرنامج',
  'The upgrade needs to be connected to the Internet, and the latest server configuration can be obtained': 'تتطلب الترقية اتصالاً بالإنترنت للحصول على أحدث تهيئة للخادم.',
  'Operation failed. Please try again after the server is connected to the Internet': 'فشِلت العملية. الرجاء المحاولة مرة اخرى بعد اتصال الخادم بالإنترنت.',
  'Operation failed. Please try again after connecting to the local area network': 'فشلت العملية. الرجاء المحاولة مرة أخرى بعد الاتصال بشبكة المنطقة المحلية (LAN).',
  'No permission. You are about to be automatically logged out': 'لا يوجد إذن. سيتم تسجيل خروجك تلقائيًا قريبًا.',
  'Insufficient license is available! Contact sales to buy more.': 'التراخيص غير كافية! يرجى زيارة صفحة الأسعار للشراء أو الاتصال بالمبيعات للحصول على المساعدة.',
  'Your annual plan has {expireTime} days to expire, please contact sales to purchase perpetual plan.': 'الخطة السنوية الخاصة بك لديها{expireTime} أيام لتنتهي صلاحيتها, الرجاء التواصل مع البائع لشراء الخطة الثابتة',
  'Password has been reset successfully. Please use the new password to log in.': 'تم إعادة ضبط كلمة المرور بنجاح. الرجاء استخدام كلمة المرور الجديدة لتسجيل الدخول.',
  'This email is used to reset the administrator password: when the administrator forgets the password, click "forgot password" on the login interface, and a verification code can be sent to this email to reset the password (the verification code needs to be connected to the Internet to receive it). When the administrator is transferred, the email will be changed accordingly, and the new administrator can also bind a new email.': 'يتم استخدام هذا البريد الإلكتروني لإعادة تعيين كلمة مرور المسؤول: عندما ينسى المسؤول كلمة المرور، انقر على ”نسيت كلمة المرور“ على واجهة تسجيل الدخول، ويمكن إرسال رمز التحقق إلى هذا البريد الإلكتروني لإعادة تعيين كلمة المرور (يتطلب رمز التحقق اتصالاً بالإنترنت ليتم استلامه.) عند نقل المسؤول، سيتم تغيير البريد الإلكتروني وفقًا لذلك، ويمكن للمسؤول الجديد أيضًا ربط بريد إلكتروني جديد.',
  'Your version is already the latest version': 'إصدارك هو أحدث إصدار بالفعل',
  'The upgrade needs to be connected to the Internet, and the latest software configuration can be obtained': 'تحتاج الترقية ان تبقى متصلاً بالإنترنت, وسيتم الحصول على آخر تكوينات البرنامج',
  'Change binding': 'تغيير الربط',
  'Privatized Enterprise Account': 'خصوصية حساب المؤسسة',
  'Enterprise Management Dashboard': 'لوحة تحكم إدارة المؤسسة',
  'When upgrading, all client software will be suspended, please remind employees to save in time': 'عند احداث الترقيات, سيتم تعليق برامج جميع العملاء, الرجاء تذكير الموظفين للحفظ في الوقت',
  'Upgrade failed, please try again': 'فشلت الترقية, الرجاء المحاولة مرة اخرى',
  'http_error_4024': 'رمز الاسترداد مخصص لخطة الأفراد، ولا يمكن استخدامه للشركات.',
  'http_error_4408': 'انتهت مدة الاتصال بالشبكة, مطلوب الاتصال بالإنترنت',
  'This version includes bug fixes and performance improvements': 'يحتوي هذا الاصدار على اصلاحات للمشاكل و تحسين للأداء',
  'UPDF Annual': 'UPDF السنوي',
  'Success! Your subscription will be renewed on {data}': 'تم بنجاح! سيتم تجديد اشتراكك في {data}',
  'You will miss the membership rights when the subscription expired.': 'ستفقد حقوق العضوية عند انتهاء صلاحية الاشتراك.',
  '⏰ <span>Expire on</span> {data}': '⏰ <span>تنتهي صلاحيته في</span> {data}',
  'Keep Subscribing': 'استمر في الاشتراك',
  'Active Subscription': 'الاشتراك النشط',
  'UPDF Sign Annually': 'UPDF Sign',
  'UPDF Sign Monthly': 'UPDF Sign',
  'Sign': 'لافتة',
  'UPDF Sign': 'UPDF Sign',
  'Your account now has full access to all UPDF Sign features.': 'يتمتع حسابك الآن بإمكانية الوصول الكامل إلى جميع ميزات UPDF Sign.',
  'Full access to all UPDF Sign features and UPDF Cloud benefits.': 'الوصول الكامل إلى جميع ميزات UPDF Sign ومزايا UPDF Cloud.',
  'UPDF Sign Authorize': 'UPDF تسجيل الدخول يأذن',
  'Buy Sign Licenses': 'شراء تراخيص التوقيع',
  'Amount of Sign plans to be redeemed': 'مبلغ خطط التوقيع المراد استردادها',
  'Sign Authorize': 'التوقيع على التفويض',
  'Sign Deauthorize': 'قم بالتوقيع على إلغاء التفويض',
  'Keep UPDF Sign': 'احتفظ بعلامة UPDF',
  'Legally binding digital signature (certified by AATL).++Automatically notify recipients when signature is sent.++Multiple file signing and batch sending.++Save and manage digital signatures for long-term use.++Provides audit trail and certification.': 'التوقيع الرقمي الملزم قانونًا (معتمد من AATL).++إعلام المستلمين تلقائيًا عند إرسال التوقيع.++توقيع ملفات متعددة وإرسال الدفعات.++حفظ التوقيعات الرقمية وإدارتها للاستخدام طويل الأمد.++يوفر مسار التدقيق والشهادة.',
  '{number} signature requests per year.': '{number} من طلبات التوقيع سنويًا.',
  '{number} signature requests per month.': '{number} طلبات التوقيع شهريًا.',
  'Legally binding digital signature (certified by AATL).': 'التوقيع الرقمي الملزم قانونًا (معتمد من AATL).',
  'Automatically notify recipients when signature is sent.': 'إعلام المستلمين تلقائيًا عند إرسال التوقيع.',
  'Multiple file signing and batch sending.': 'توقيع ملفات متعددة وإرسال دفعة.',
  'Save and manage digital signatures for long-term use.': 'حفظ وإدارة التوقيعات الرقمية للاستخدام على المدى الطويل.',
  'Provides audit trail and certification.': 'يوفر مسار التدقيق والشهادة.',
  '20GB cloud storage.': 'تخزين سحابي سعة 20 جيجابايت.',
  '24*7 customer service support.': 'دعم خدمة العملاء 24*7.',
  'Register & log in UPDF account You can convert <span>2 files per day</span> for FREE': 'قم بالتسجيل وتسجيل الدخول إلى حساب UPDF يمكنك تحويل <span>ملفين يوميًا</span> مجانًا',
  'The annual membership signature quota is unlimited and cannot be modified after authorization to employees. Confirm the authorization?': 'تتضمن الخطة السنوية لـ UPDF Sign طلبات توقيع غير محدودة. بمجرد تفويضك لموظف ما، لا يمكنك نقل التفويض إلى موظف آخر. هل تؤكد التفويض؟',
  'Authorized employees do not support cancellation. If you need to change, you can contact sales to modify it once.': 'لا يدعم الموظفون المعتمدون الإلغاء. إذا كنت بحاجة إلى التغيير، يمكنك الاتصال بالمبيعات لتعديله مرة واحدة.',
  'Usage of amount': 'معلومات عن الاستخدام:',
  'Total signature amount:': 'مجموع طلبات التوقيع:',
  'Expiration date:': 'تاريخ انتهاء الصلاحية:',
  'Remaining amount:': 'طلبات التوقيع المتبقية:',
  'Usage of Amount Detail': 'معلومات عن الاستخدام التفصيلي:',
  'Amount Consumed': 'طلبات التوقيع المستخدمة:',
  'Last Consumption Time': 'وقت الاستخدام الأخير:',
  'According to the billing process of relevant institutions, we will complete the billing for users every Wednesday': 'وفقًا لعملية الفوترة الخاصة بالمؤسسات ذات الصلة، سنقوم بإكمال الفوترة للمستخدمين كل يوم أربعاء',
  'If you need to create a personal account for use, click here': 'إذا كنت بحاجة إلى إنشاء حساب شخصي للاستخدام، انقر هنا',
  'Cancelled': 'تم الإلغاء',
  'http_error_403': 'لا يوجد إذن',
  'http_error_408': 'طلب مهلة. حاول مرة اخرى',
  'http_error_500': 'خطأ في النظام أو المعلمات. حاول مرة اخرى',
  'http_error_1401': 'فشل التحقق. يرجى التحقق من بيانات الإدخال الخاصة بك',
  'http_error_2001': 'الحساب موجود بالفعل',
  'http_error_2002': 'رمز التحقق غير صالح. حاول مرة اخرى',
  'http_error_2003': 'تم إرسال عدد كبير جدًا من رموز التحقق. الرجاء معاودة المحاولة في وقت لاحق',
  'http_error_2004': 'محاولات تسجيل دخول كثيرة جدًا من عنوان IP الخاص بك. الرجاء معاودة المحاولة في وقت لاحق',
  'http_error_2005': 'أكثر من 5 محاولات فاشلة لكلمة المرور',
  'http_error_2006': 'انتهت صلاحية جلستك. الرجاء إعادة تسجيل الدخول',
  'http_error_2007': 'أنت تقوم بتسجيل الدخول والخروج بشكل متكرر جدًا',
  'http_error_2008': 'استثناء الجلسة، يرجى تسجيل الدخول مرة أخرى',
  'http_error_2009': 'لم تقم بتسجيل الدخول. الرجاء تسجيل الدخول',
  'http_error_2012': 'تم ربط الحساب، يرجى إلغاء ربط الحساب أو حذفه والمحاولة مرة أخرى',
  'http_error_2403': 'الحساب أو كلمة المرور غير صحيحة',
  'http_error_2404': 'الحساب غير موجود',
  'http_error_2411': 'فشل إرسال البريد الإلكتروني! يرجى المحاولة مرة أخرى أو التحقق من عنوان بريدك الإلكتروني.',
  'http_error_4004': 'لا يدعم التجديد',
  'http_error_4005': 'الترخيص المستخدم.',
  'http_error_4006': 'تم الغاء الترخيص',
  'http_error_4007': 'كان الترخيص غير متصل',
  'http_error_4008': 'تم حذف الترخيص',
  'http_error_4009': 'الرخصة انتهت',
  'http_error_4015': 'لا يمكنك استخدام هذه القسيمة على هذا المنتج',
  'http_error_4016': 'تم الوصول إلى حد استخدام القسيمة.',
  'http_error_4019': 'لم يتم العثور على بيانات البضائع.',
  'http_error_4020': 'القسيمة غير موجودة',
  'http_error_4021': 'لم يتم العثور على بيانات الطلب.',
  'http_error_4022': 'لم يتم العثور على بيانات الخطة.',
  'http_error_4026': 'لقد انتهت صلاحية الكود المسترد.',
  'http_error_4027': 'القسيمة غير موجودة',
  'http_error_4028': 'أنت عضو دائم بالفعل، لا حاجة للاسترداد.',
  'http_error_4014': 'الحساب غير مطابق',
  'http_error_4401': 'الحصول على خطأ رمز الخادم',
  'http_error_4404': 'لم يتم العثور على بيانات',
  'http_error_4502': 'انتهى الوقت، يرجى المحاولة مرة أخرى',
  'http_error_6004': 'لا يمكن حذف نفسك',
  'http_error_6001': 'لا يمكن آن تأذن لنفسك',
  'http_error_6002': 'لا يمكن الغاء الترخيص لنفسك',
  'http_error_6003': 'التراخيص غير كافية',
  'http_error_6005': 'انتهت صلاحيه رمز الدعوة',
  'http_error_6506': 'البيانات المصدرة فارغة',
  'http_error_6507': 'الاستيراد لم يكتمل',
  'http_error_6508': 'الملف المستورد فارغ',
  'http_error_6509': 'تنسيق Excel غير صالح',
  'http_error_6012': 'البريد الالكتروني موجود بالفعل',
  'http_error_6013': 'رقم الهاتف موجود بالفعل',
  'http_error_6006': 'تم تعطيل المؤسسة الحالية',
  'http_error_2204': 'خطة اشتراكك نشطة، يرجى إلغاء اشتراكك قبل حذف الحساب.',
  'UPDF Account Center': 'مركز حساب UPDF',
  'Profile': 'الملف الشخصي',
  'Products and Plans': 'المنتجات والخطط',
  'Payment and Order': 'الدفع والطلب',
  'Account Settings': 'إعدادات الحساب',
  'Account Types': 'أنواع الحسابات',
  'Save Changes': 'حفظ التغييرات',
  'Newsletter Subscription Preferences': 'تفضيلات اشتراك النشرة الإخبارية',
  'Subscribe to our newsletter about news, offers and tips.': 'اشترك في النشرة الإخبارية الخاصة بنا للحصول على الأخبار والعروض والنصائح.',
  'Redeem License': 'استرداد الترخيص',
  'You can manage the credit card for your subscription order here. Credit cards are stored by third-party payment institutions, and we at UPDF do not store any credit card information. If you need to unbind, please cancel your subscription in “Product and Plans” first.': 'يمكنك إدارة بطاقة الائتمان لطلب الاشتراك هنا. يتم تخزين بطاقات الائتمان بواسطة مؤسسات الدفع الخارجية، ونحن في UPDF لا نقوم بتخزين أي معلومات عن بطاقات الائتمان. إذا كنت بحاجة إلى إلغاء الربط، يرجى إلغاء اشتراكك أولاً في قسم "المنتجات والخطط".',
  'Order information only included orders purchased through rhe website. Apple Pay and Google Pay orders will not be displayed here.': 'تتضمن معلومات الطلبات فقط الطلبات التي تم شراؤها عبر الموقع. لن يتم عرض الطلبات التي تمت باستخدام Apple Pay وGoogle Pay هنا.',
  'Card Details': 'تفاصيل البطاقة',
  'Device Name': 'اسم الجهاز',
  'Location': 'الموقع الجغرافي',
  'Manage': 'إدارة',
  'Linked Account': 'الحساب المرتبط',
  'Status': 'الحالة',
  'Actions': 'الإجراءات',
  'No data': 'لا توجد بيانات',
  'Log in with WeChat Scan': 'تسجيل الدخول باستخدام WeChat',
  'Log in with Account/Email/Phone Number': 'تسجيل الدخول باستخدام الحساب/البريد الإلكتروني/رقم الهاتف',
  'Registration is successful! Please fill in the following information': 'تم التسجيل بنجاح! يُرجى ملء المعلومات التالية',
  'Get Started': 'ابدأ',
  'Subscribe to our newsletter, Offers and Tips.': 'اشترك في النشرة الإخبارية والعروض والنصائح.',
  'Please verify you are human': 'يرجى التحقق من كونك إنسانًا',
  'Let us get to know you better': 'دعنا نتعرف عليك بشكل أفضل',
  'How do you plan to use UPDF?': 'كيف تخطط لاستخدام UPDF؟',
  'For personal use': 'للاستخدام الشخصي',
  'For work': 'للعمل',
  'For my study or education work': 'لدراستي أو عملي التعليمي',
  'How did you hear about us?': 'كيف سمعت عنا؟',
  'Search (Google, Bing, etc.)': 'البحث (Google، Bing، إلخ.)',
  'Internet(newsletter, publication, blog etc.)': 'الإنترنت (النشرة الإخبارية، المنشور، المدونة، إلخ.)',
  'Internet ads': 'إعلانات الإنترنت',
  'Youtube': 'Youtube',
  'Tiktok': 'TikTok',
  'Social media(Linkedin, Facebook, X, instagram etc.)': 'وسائل التواصل الاجتماعي (Linkedin، Facebook، X، instagram، إلخ.)',
  'From a friend or colleague': 'من صديق أو زميل',
  'Others(please specify)': 'آخرون (يرجى التحديد)',
  'Please specify': 'يرجى التحديد',
  'What features do you plan to use with UPDF?': 'ما هي الميزات التي تخطط لاستخدامها مع UPDF؟',
  'AI': 'AI',
  'Edit PDF': 'تحرير PDF',
  'Annotate PDF': 'التعليق على PDF',
  'Convert PDF': 'تحويل PDF',
  'OCR': 'OCR(التعرف الضوئي على الحروف)',
  'Create, fill and sign PDFs': 'إنشاء ملفات PDF وملؤها وتوقيعها',
  'Organize PDF pages': 'تنظيم صفحات PDF',
  'Redact and protect PDFs': 'تحرير ملفات PDF وحمايتها',
  'I don\'t know yet': 'لا أعرف حتى الآن',
  'What’s your age group?': 'ما هي الفئة العمرية الخاصة بك؟',
  'Under 18': 'أقل من 18 عامًا',
  '18-24': '18-24',
  '25-34': '25-34',
  '35-44': '35-44',
  '45-54': '45-54',
  '55-64': '55-64',
  '65 and over': '65 عامًا فأكثر',
  'I prefer not to say': 'لا أريد أن أقول',
  'What kind of work do you do?': 'ما نوع العمل الذي تقوم به؟',
  'Select your role or job title': 'اختر دورك أو المسمى الوظيفي',
  'Education (students or education Staff)': 'التعليم (طلاب أو موظفو التعليم)',
  'Healthcare': 'الرعاية الصحية',
  'IT': 'تكنولوجيا المعلومات',
  'Finance': 'المالية',
  'Legal': 'القانونية',
  'Creative industries': 'الصناعات الإبداعية',
  'Engineering': 'الهندسة',
  'Goverment and public service': 'الحكومة والخدمة العامة',
  'Non-profit and NGOs': 'المنظمات غير الربحية والمنظمات غير الحكومية',
  'Media and entertainment': 'الإعلام والترفيه',
  'Marketing and advertising': 'التسويق والإعلان',
  'Energy and utilities': 'الطاقة والمرافق',
  'Manufacturing_1': 'التصنيع',
  'Real estate': 'العقارات',
  'Human resource': 'الموارد البشرية',
  'Telecommunication': 'الاتصالات',
  'Consulting': 'الاستشارات',
  'Building and construction': 'البناء والتشييد',
  'Retired': 'المتقاعدون',
  'Others': 'آخرون',
  'Tell us a bit more': 'أخبرنا المزيد',
  'Next': 'التالي',
  'Skip All': 'تخطي الكل',
  'Finish': 'إنهاء',
  'Registration is successful!': 'تم التسجيل بنجاح!',
  'Change Payment Method': 'تغيير طريقة الدفع',
  'http_error_1400': 'فشل التحقق البشري',
  'http_error_2400': 'فشل التحقق من البريد الإلكتروني.',
  'http_error_6011': 'الحساب موجود بالفعل',
  'Feedback': 'التعليقات',
  'Very Dissatisfied': 'غير راضٍ تمامًا',
  'Dissatisfied': 'غير راضٍ',
  'Neutral': 'محايد',
  'Satisfied': 'راضٍ',
  'Very Satisfied': 'راضٍ جدًا',
  'Attachment': 'المرفق',
  'Is there anything we can help you with?': 'هل هناك أي شيء يمكننا مساعدتك به؟',
  'Your email': 'بريدك الإلكتروني',
  'Hello, we have received your feedback and will respond to you as soon as possible. Please be patient, and thank you for your understanding.': 'مرحبًا، لقد تلقينا تعليقاتك وسنرد عليك في أقرب وقت ممكن. يرجى التحلي بالصبر، ونشكرك على تفهمك.',
  'Submission Failed': 'فشل الإرسال',
  'Please correctly fill in your email address.': 'يرجى ملء عنوان بريدك الإلكتروني بشكل صحيح.',
  'Invalid email address, please re-enter.': 'عنوان بريد إلكتروني غير صالح، يرجى إعادة إدخاله.',
  'Please provide detailed feedback content.': 'يرجى تقديم محتوى تعليق مفصل.',
  'Unbind Card': 'إلغاء ربط البطاقة',
  'Are you sure you want to unlink this credit card?': 'هل أنت متأكد أنك تريد إلغاء ربط بطاقة الائتمان هذه؟',
  'Unbind': 'إلغاء الارتباط',
  'Use email verification': 'استخدم التحقق من البريد الإلكتروني',
  'Use phone verification': 'التحقق باستخدام رقم الهاتف المحمول',
  'Permanently delete your personal information and all data, this operation can’t be reconvered.': 'سيتم حذف معلوماتك الشخصية وجميع بياناتك بشكل دائم ولن يمكن استعادتها.',
  'Please select one of the currently linked accounts to receive the verification code to proceed with your account deactivation.': 'الرجاء اختيار أحد الحسابات المرتبطة للتحقق',
  'Other verification methods': 'طرق التحقق الأخرى',
  'All devices that have permission to log in to this account will be displayed here. If you do not want a device to continue logging into the account, you can remove the device in time and <a href="#" class="change-pass">change the password</a>.': 'سيتم عرض جميع الأجهزة التي لديها إذن بتسجيل الدخول إلى هذا الحساب هنا. إذا كنت لا تريد أن يستمر الجهاز في تسجيل الدخول إلى الحساب، فيمكنك إزالة الجهاز في الوقت المناسب<a href="#" class="change-pass"> وتغيير كلمة المرور</a>.',
  'All devices that have permission to log in to this account will be displayed here. If you do not want a device to continue logging into the account, you can remove the device in time.': 'سيتم عرض جميع الأجهزة التي لديها إذن بتسجيل الدخول إلى هذا الحساب هنا. إذا كنت لا تريد أن يستمر الجهاز في تسجيل الدخول إلى الحساب، فيمكنك إزالة الجهاز في الوقت المناسب وتغيير كلمة المرور.',
  '<span>{inviteNickName}</span> invites you to join <span>{companyName}</span> to share UPDF membership benefits.': 'يدعوك <span>{inviteNickName}</span> للانضمام إلى <span>{companyName}</span> لمشاركة مزايا عضوية UPDF.',
  'You’ve been invited': 'لقد تمت دعوتك',
  'Free Trial': 'تجربة مجانية',
  'Accept now to access exclusive UPDF membership benefits.': 'قم بالقبول الآن للوصول إلى مزايا عضوية UPDF الحصرية.',
  'Accept Invitation': 'قبول الدعوة',
  'Welcome aboard! You’re all set.': 'مرحباً بك معنا! أنت جاهز تماماً.',
  'Download now to share membership benefits.': 'قم بتنزيل UPDF وقم بتسجيل الدخول لاستخدام جميع ميزاته.',
  'Start Using UPDF': 'ابدأ في استخدام UPDF',
  'Account Details': 'تفاصيل الحساب',
  'After unsubscribing, you will no longer receive our email notifications, news, offers, and tips.': 'بعد إلغاء الاشتراك، لن تتلقى رسائل البريد الإلكتروني الخاصة بنا حول الأخبار والعروض والنصائح.',
  'You can manage the credit card for your subscription order here. Credit cards are stored by third-party payment institutions, and we at UPDF do not store any credit card information. If you need to unbind, please cancel your subscription in “Product & Plans” first.': 'يمكنك إدارة بطاقة الائتمان لطلب الاشتراك الخاص بك هنا. يتم تخزين بطاقات الائتمان بواسطة مؤسسات دفع تابعة لجهات خارجية، ولن تخزن UPDF أي معلومات عن بطاقة الائتمان. إذا كنت بحاجة إلى إلغاء ربط بطاقاتك، فيرجى إلغاء اشتراكك في "المنتجات والخطط" أولاً.',
  'Order information only included orders purchased through rhe website. Apple Pay and Google Google Pay orders will not be displayed here.': 'تسرد معلومات الطلب الطلبات المقدمة من خلال الموقع الرسمي لـ UPDF فقط. لن يتم عرض الطلبات من منصات تابعة لجهات خارجية مثل Apple Store أو Google Play Store أو مواقع الصفقات الأخرى هنا.',
  'Work': 'العمل',
  'Age': 'العمر',
  'Please enter the code sent to<br><span>{account}</span>.': 'يرجى إدخال الرمز المرسل إلى<span>{account}</span>',
  'The code is valid for 10 minutes.': 'الرمز صالح لمدة 10 دقائق.',
  'SSO Log in': 'تسجيل الدخول SSO',
  'Upgrade AI Assistant to unlock more AI features': 'قم بترقية مساعد AI لفتح المزيد من ميزات AI',
  'Profile Picture': 'صورة الملف الشخصي',
  'Account Deletion Confirmation': 'تأكيد حذف الحساب',
  'Email/phone number': 'البريد الإلكتروني/رقم الهاتف',
  'Account/email/phone number': 'الحساب/البريد الإلكتروني/رقم الهاتف',
  'Account/email': 'الحساب/البريد الإلكتروني',
  'Get our desktop/mobile app': 'احصل على تطبيق UPDF لسطح المكتب/الجوال',
  'Plan Types': 'أنواع الخطط',
  'Details': 'التفاصيل',
  'Redeemable {isProduct} Membership Duration:': 'مدة عضوية {isProduct} القابلة للاسترداد:',
  'Redeemable Membership Duration:': 'مدة عضوية القابلة للاسترداد:',
  'Tax Code': 'قانون الضرائب',
  'http_error_4031': 'لقد حصلت على خطة بالفعل، ولا داعي للشراء مرة أخرى',
  'Send code_2': 'إرسال الرمز',
  'View Plans': 'عرض الخطط',
  'Add Credit Card': 'إضافة بطاقة ائتمان',
  'Account Information': 'معلومات الحساب',
  'There are no orders. Would you like to upgrade your plan? <br>Please visit the pricing page to make a purchase.': 'لا يوجد معلومات الطلبات. هل ترغب في ترقية خطتك؟ <br>يرجى زيارة صفحة التسعير لإجراء عملية شراء.',
  'Human-machine verification failed, <span>click to retry</span>': 'فشل التحقق بين الإنسان والآلة،</span> انقر لإعادة المحاولة<span>',
  'Subscribed Successfully': 'تم الاشتراك بنجاح',
  'Unsubscribe': 'إلغاء الاشتراك',
  'Upgrade to UPDF Sign Plan to unlock more Sign features': 'قم بالترقية إلى خطة UPDF Sign لفتح المزيد من ميزات التوقيع',
  'Subscribe': '신청',
  'Please scan the QR code using WeChat': 'QR코드를 스캔하려면 WeChat을 사용하세요.',
  'Enter your redemption code': 'أدخل رمز الاسترداد الخاص بك',
  'Credit Card': 'بطاقة إئتمان',
  'Renews on {time} at {price}/{type}': 'تجديد في {time} بسعر {price}/{type}',
}